<!-- Marketplace listing details (desktop) -->
<a class="fmp mpx" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
  <div class="mpx-media">
    <img class="fmp-logo mpx-logo" [src]="avatar" alt="" />
    <app-meta-creative class="fmp-image mpx-image" [src]="data.creative" [kind]="data.creativeKind" slot="cover"></app-meta-creative>
  </div>
  <!-- "(Uobičajeno)" is Ads Manager's own label on this placement -->
  <div class="fmp-ellipsis mpx-name">{{ pageName }} (Uobičajeno)</div>
  <div class="fmp-ellipsis fmp-muted mpx-headline">{{ headline }}</div>
</a>
